const storyblokGlobalData = {
    blokMap: {},
    additionalDataHook: async ()=>({})
};
const getAdditionalDataHook = ()=>{
    return storyblokGlobalData.additionalDataHook;
};
const getBlokComponent = (key)=>{
    return storyblokGlobalData.blokMap[key];
};
/**
 * Define bloks for StoryblokStory & StoryblokComponent to use.
 * Import this file at the root layout both on client and server
 * @example
 * ```ts
 * import { PageBlok } from "@/components/bloks"
 * type StoryblokTypes = PageStoryblok;
 *
 * defineBloks<StoryblokTypes>({
 *    page: PageBlok,
 * })
 * ```
 *
 * @example - layout.tsx, _Providers.tsx
 * ```ts
 * import "@/lib/bloks"
 *
 * export default function Layout({ children }) {}
 * ```
 */ function defineStoryblok({ bloks, additionalDataHook }) {
    storyblokGlobalData.blokMap = bloks;
    if (additionalDataHook) {
        storyblokGlobalData.additionalDataHook = additionalDataHook;
    }
    return {
        bloks,
        additionalDataHook
    };
}

export { getAdditionalDataHook as a, defineStoryblok as d, getBlokComponent as g, storyblokGlobalData as s };
